import {
  FooterWidgetBlockType,
  processLayoutOptions,
  MenuItem,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";

export const layoutOptions = {};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type SitemapType = {
  title: string;
  menu: MenuItem[];
} & FooterWidgetBlockType<LayoutProps>;
